<template>
  <svg
    fill="none"
    viewBox="0 0 19 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8703 4.07925L14.2118 0.42075C13.9418 0.15075 13.575 0 13.1925 0H1.01102C0.612766 0 0.291016 0.32175 0.291016 0.72V17.28C0.291016 17.6783 0.612766 18 1.01102 18H17.571C17.9693 18 18.291 17.6783 18.291 17.28V5.09625C18.291 4.71375 18.1403 4.34925 17.8703 4.07925ZM6.41102 1.44H12.171V3.96H6.41102V1.44ZM9.29102 13.905C7.50227 13.905 6.05102 12.4538 6.05102 10.665C6.05102 8.87625 7.50227 7.425 9.29102 7.425C11.0798 7.425 12.531 8.87625 12.531 10.665C12.531 12.4538 11.0798 13.905 9.29102 13.905ZM9.29102 8.865C8.29652 8.865 7.49102 9.6705 7.49102 10.665C7.49102 11.6595 8.29652 12.465 9.29102 12.465C10.2855 12.465 11.091 11.6595 11.091 10.665C11.091 9.6705 10.2855 8.865 9.29102 8.865Z"
      fill="white"
    />
  </svg>
</template>
